/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_Qty_OrderedInputs */

const en_po_col_qty_ordered = /** @type {(inputs: Po_Col_Qty_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordered`)
};

/**
* | output |
* | --- |
* | "Ordered" |
*
* @param {Po_Col_Qty_OrderedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_qty_ordered = /** @type {((inputs?: Po_Col_Qty_OrderedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_Qty_OrderedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_qty_ordered(inputs)
});